import React from 'react'
import t from '../../translations/i18n'
import '../../scss/envio.scss'

export default function Envio() {
  return (
    <div className="page-content easybuy-shipping-page">
      <div className="container">
        <div className="easybuy-shipping-header text-center">
          <span className="easybuy-shipping-badge">
            <i className="la la-truck"></i>
            Envíos
          </span>

          <h2>{t('envio.tittle')}</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="easybuy-shipping-card">
              <div className="easybuy-shipping-item">
                <div className="easybuy-shipping-icon">
                  <i className="la la-map-marker"></i>
                </div>

                <p>{t('envio.p_1')}</p>
              </div>

              <div className="easybuy-shipping-item">
                <div className="easybuy-shipping-icon">
                  <i className="la la-clock-o"></i>
                </div>

                <p>{t('envio.p_2')}</p>
              </div>

              <div className="easybuy-shipping-item">
                <div className="easybuy-shipping-icon">
                  <i className="la la-truck"></i>
                </div>

                <p>{t('envio.p_3')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
